






































import { Vue } from "vue-property-decorator"

export default Vue.extend({
  name      : "StadiumCurator",
  props     : {
    id               : { type: String, required: true },
    button           : { type: Boolean, default: true },
    editable         : { type: Boolean, required: true },
    business_days_new: { type: Array, required: true },
    correct          : { type: Object, default() { return {} } },
    show             : { type: Boolean, default: true },
  },
  data() {
    return {
      data   : [] as Array<any>,
      origin : [] as Array<any>,
      change : [] as Array<any>,
      columns: [
        { align: "center", title: "", scopedSlots: { customRender: 'action' } },
        { align: "center", title: "节日", scopedSlots: { customRender: 'holiday' } },
        { align: "center", title: "天数（按年平均天数填写）", scopedSlots: { customRender: 'days' } },
      ],
    }
  },
  computed: {
    if_correct() {
      return (index: number): string => {
        let is_correct = ""
        if (this.data.length > index) {
          const data = this.$deep_copy(this.data[index])
          if (this.origin.length > index) {
            const compare = this.$deep_copy(this.origin[index])
            for (const k in data) {
              if (Object.prototype.hasOwnProperty.call(data, k)) {
                if (data[k] != compare[k]) {
                  is_correct = "is_correct"
                  break
                } else is_correct = ""
              }
            }
          } else is_correct = "is_correct"
        } return is_correct
      }
    }
  },
  methods: {
    init() {
      this.$nextTick(() => {
        const days = this.business_days_new as string[]
        const temp = []
        for (const v of days) {
          const item = v.split(",")
          temp.push({ holiday: item[0], days: item[1] })
        }
        this.data   = this.$deep_copy(temp)
        this.origin = this.$deep_copy(temp)
      })
    },
    add_row() {
      this.data.push({ holiday: "", days: 0 })
    },
    show_correct(): boolean {
      let change = false
      if (this.change.length == 0) return false
      const data = this.$deep_copy(this.data)
      const compare = this.$deep_copy(this.change)
      if (data.length != compare.length) return true
      for (const k in data) {
        if (Object.prototype.hasOwnProperty.call(data, k) && Object.prototype.hasOwnProperty.call(compare, k)) {
          for (const key in data[k]) {
            if (Object.prototype.hasOwnProperty.call(data[k], key)) {
              if (data[k][key] != compare[k][key]) {
                change = true
                break
              } change = false
            }
          }
        } else change = false
      }
      return change
    },
    onCellChange(i: number, t: string, e: any) {
      const source = [...this.data];
      const target = source[i]
      if (target) {
        target[t] = e.target.value;
        this.data = source;
      }
    },
    remove(index: string) {
      this.$confirm({
        content: "确定删除这条记录？",
        onOk: () => {
          const data = []
          for (const k in this.data) {
            if (this.data[k] && k != index) {
              data.push(this.data[k])
            }
          }
          this.data = this.$deep_copy(data)
        }
      })
    },
    submit() {
      const new_days = []
      for (const v of this.data) {
        if (v.days > 0) {
          new_days.push([v.holiday, v.days].join(","))
        }
      }
      const params = { estimate_id: this.id, business_days_new: new_days.join(";") }
      this.$emit("update:business_days_new", new_days)
      this.$emit("save", params)
    },
    modify() {
      const new_days = []
      for (const v of this.data) {
        if (v.days > 0) {
          new_days.push([v.holiday, v.days].join(","))
        }
      }
      const params = { business_days_new: new_days } as any
      params.estimate_id = this.id
      if (JSON.stringify(this.business_days_new) != JSON.stringify(new_days)) {
        this.$emit("modify", params)
      }
    }
  },
  watch: {
    data: {
      handler() {
        this.modify()
        if (Object.prototype.hasOwnProperty.call(this.correct, "business_days_new")) {
          const days = this.correct.business_days_new as string[]
          const temp = []
          for (const v of days) {
            const item = v.split(",")
            temp.push({ holiday: item[0], days: item[1] })
          }
          this.change = temp
        }
      },
      deep: true
    }
  }
})
